import React, { useState } from "react";
import CSidebar from "./ConsultantSidebar/CSidebar";
import Header from "../Dashboard/Header";
import Cookies from "js-cookie";
import "../Dashboard/Dashboard.css";
import { Outlet } from "react-router-dom";
//Sanket Raut
//create sidebar to render the content of  consultant
const CDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("dashboard");
  const [selectedJob, setSelectedJob] = useState(null);
  const username = Cookies.get("username") || "User";

  return (
    <div className="d-flex">
      <CSidebar
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
        onSelectMenu={setSelectedMenu}
      />
      <div className="flex-grow-1 dashboard-main">
        <Header
          toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
          isSidebarOpen={sidebarOpen}
        />

        <main
          className={`bg-light  min-vh-100  d-flex flex-column mt-4 align-items-center justify-content-start app-wrapper`}
        >
          {<Outlet /> }
        </main>

        {/* <footer className="text-center text-muted small py-3 border-top bg-white">
          © 2025 - Design and Developed by VRSamadhan <a href="#">Privacy</a>
        </footer> */}
      </div>
    </div>
  );
};

export default CDashboard;
